const initialState = {
    data:[],
    maximizeMap: false,
    miniMapHeight: "175px",
    miniMapWidth: "300px",
    maxMapHeight: "600px",
    maxMapWidth: "300px"
};

export default function mapReducer(state = initialState, action) {
    switch (action.type) {
        case "CHANGE_CAMERA_ON_MAP":
            return {
                ...state,
                data: action.payload
            };
        case "SET_MAXIMIZE_MAP":
            return {
                ...state,
                maximizeMap: action.payload
            };     
        default:
            return state;
    }
}